<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :fill="color"
  >
    <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
      <g id="1920-1320安全区" transform="translate(-1842.000000, -689.000000)">
        <g id="侧边栏" transform="translate(1822.000000, 622.000000)">
          <g id="电话咨询" transform="translate(0.000000, 62.000000)">
            <g id="编组-16" transform="translate(20.000000, 5.000283)">
              <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M8.36365144,9.07057906 C9.39132734,8.04290227 10.3047866,7.41488626 8.47777033,5.13111882 C6.65077357,2.84741001 5.39474261,4.56021116 4.42409683,5.58788794 C3.28228249,6.72978143 4.3670667,11.0689024 8.64909525,15.3509346 C12.9311238,19.6329668 17.2131524,20.717752 18.4121336,19.5758585 C19.4398095,18.5481817 21.1526092,17.3491798 18.8688242,15.5221815 C16.5851369,13.6952418 15.9570432,14.6087019 14.9293673,15.6363787 C14.1871352,16.3786114 12.3601385,14.8370572 10.7615554,13.2384727 C9.16289412,11.6398101 7.62141934,9.81281178 8.36365144,9.07057906 Z"
                id="Fill-1"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
  components: {},
  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="less" scoped></style>
